var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isReady)?_c('v-checkbox',{attrs:{"label":"Pending review / do not bill"},on:{"click":_vm.save},model:{value:(_vm.isInvoiced),callback:function ($$v) {_vm.isInvoiced=$$v},expression:"isInvoiced"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }